export default angular
  .module('gm.wealth.common')
  .filter('gmwTruncate', gmwTruncateFilter)
  .name;

function gmwTruncateFilter() {
  'ngInject';

  return (input, length) => {
    if (!input) {
      return input;
    }
    return input.length > length ? `${input.substring(0, length)}…` : input;
  };
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/filters/truncate.js